import dayjs from "dayjs";
export const dateSort = (d1, d2, desc = true) => {
    const comparison = dayjs(d1).isAfter(dayjs(d2)) ? 1 : -1;
    return desc ? -comparison : comparison;
};
